



























































import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { IS_RECAPTCHA_V2_USED } from '@/types/authentication.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';

@Component({})
export default class FormWidget extends Vue {

  @Inject() public $validator: any;

  @Prop() public requestorCallback!: any;
  @Prop(String) public buttonText!: string;
  @Prop(String) public btnClasses!: string;
  @Prop(String) public serverErrorClasses!: string;
  @Prop(String) public submitBtnClass!: string;
  @Prop(String) public cancelBtnClass!: string;
  @Prop(String) public cancelBtnText!: string;
  @Prop(String) public recaptchaSize!: string;
  @Prop(String) public mdIcon!: string;
  @Prop({ type: String, default: 'payrollForm' }) public formName!: string;
  @Prop({ type: String, default: 'column' }) public formDirection!: string;
  @Prop({ type: [String, Array], default: () => ['fal', 'exclamation-triangle'] }) public faIcon!: string | [];
  @Prop(Array) public serverErrorMessages!: string[];
  @Prop(Array) public buttonIcon!: string[];
  @Prop(Boolean) public buttonIconSpin!: boolean;
  @Prop(Boolean) public buttonDisabled!: boolean;
  @Prop(Boolean) public buttonLoading!: boolean;
  @Prop(Boolean) public showReCaptcha!: boolean;
  @Prop(Boolean) public showCancelBtn!: boolean;
  @Prop(Boolean) public showWarningIcon!: boolean;
  @Prop(Boolean) public enableButtonOnSubmit!: boolean;
  @Prop(Boolean) public dontLoadRecaptchaScript!: boolean;

  public readonly siteKey: any = process.env.VUE_APP_RECAPTCHA_SITE_KEY;

  @Getter(IS_RECAPTCHA_V2_USED, StoreNamespace.AUTHENTICATION) public isRecaptchaV2Used!: boolean;

  public recaptchaV2Response = '';
  public hasRecaptchaV2Error = false;

  @Watch('serverErrorMessages')
  public onServerErrorChange(newError: string[], oldError: string[]) {
    window.scrollTo(0, 0);
    this.resetRecaptcha();
  }

  public submitDisabled(errors: any) {
    if (this.buttonDisabled) {
      return true;
    }

    if (this.enableButtonOnSubmit) {
      return false;
    }

    return this.formName ? errors.any(this.formName) : errors.any();
  }

  public created() {
    const loadRecaptchaScript = !!this.siteKey && !this.dontLoadRecaptchaScript;

    if (loadRecaptchaScript) {
      const reCaptchaScript = document.createElement('script');
      reCaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?hl=iw&onload=vueRecaptchaApiLoaded&render=explicit');
      reCaptchaScript.setAttribute('async', 'true');
      reCaptchaScript.setAttribute('defer', 'true');
      document.head!.appendChild(reCaptchaScript);
    }

    if (this.requestorCallback) {
      this.requestorCallback.$on('executeFormSubmit', this.onSubmit);
    }
  }

  public onErrorFieldIdClicked(FieldId: string) {
    if ((document.getElementById(FieldId) as HTMLElement)) {
      (document.getElementById(FieldId) as HTMLElement).focus();
      ((document.getElementById(FieldId) as HTMLElement).closest('.field') as HTMLHRElement).className += ' is-error';
    }
  }

  public verifyRecaptchaV2(response: string): void {
    this.recaptchaV2Response = response;
    this.hasRecaptchaV2Error = false;
  }

  public expiredRecaptchaV2(): void {
    this.recaptchaV2Response = '';
    this.hasRecaptchaV2Error = true;
  }

  public onSubmit() {
    this.$validator.validateAll(this.formName).then((result: any) => {
      if (!result) {
        setTimeout(() => {
          let firstInput: HTMLElement = document.querySelectorAll('input.is-error')[0] as HTMLElement;
          if (!firstInput) {
            const dropdown: HTMLElement = document.querySelectorAll('.dropdown.is-error')[0] as HTMLElement;
            if (dropdown) {
              firstInput = document.querySelectorAll('.dropdown.is-error input')[0] as HTMLElement;
            }
          }
          if (firstInput) {
            firstInput.focus();
          }
        });
        this.resetRecaptcha();
        return;
      }
      if (this.isRecaptchaV2Used) {
        if (!this.recaptchaV2Response) {
          this.hasRecaptchaV2Error = true;

          return;
        }
        this.$emit('submitForm', this.recaptchaV2Response);
      } else {
        this.$emit('submitForm');
        this.$validator.reset();
      }
    });
  }

  public resetRecaptcha() {
    this.$root.$emit('resetRecaptcha');
    // setTimeout(() => {
    //   if (this.$refs.invisibleRecaptcha) {
    //     (this.$refs.invisibleRecaptcha as any).reset(); // Direct call reset method
    //   }
    // }, 1000);
  }

  public onCancel(): void {
    this.$validator.reset();
    this.$emit('cancelForm');
  }
}
